import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';

import {
  evidenceDivertOriginSessionIdAtom,
  isWorkComposerModeUnsavedAtom,
  openEvidenceChatSessionIdAtom,
  setWorkComposerModeAtom,
} from './work-composer-mode-state';

/**
 * Drop an unsaved Evidence divert once another clinical host's composer/pane
 * mounts, so that host hydrates from the saved work-home preference instead of
 * inheriting Evidence.
 *
 * Lives outside `use-persisted-work-mode` so suites that stub that module still
 * get the real clear behaviour when they render the pane/composer.
 */
export const useClearUnsavedEvidenceDivertOnHostChange = (hostId: string): void => {
  const origin = useAtomValue(evidenceDivertOriginSessionIdAtom);
  const isUnsaved = useAtomValue(isWorkComposerModeUnsavedAtom);
  const setMode = useSetAtom(setWorkComposerModeAtom);
  const setOrigin = useSetAtom(evidenceDivertOriginSessionIdAtom);
  const setEvidenceChatOpen = useSetAtom(openEvidenceChatSessionIdAtom);

  useEffect(() => {
    if (origin == null || origin === hostId) return;
    setOrigin(null);
    setEvidenceChatOpen(null);
    if (isUnsaved) setMode(null, false);
  }, [hostId, origin, isUnsaved, setMode, setOrigin, setEvidenceChatOpen]);
};
